import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Utils } from '../../shared/util';
import { RestaurantService } from '../../services/restaurant.service';
import { StorageService } from '../../services/storage.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-breed',
  templateUrl: './breed.page.html',
  styleUrls: ['./breed.page.scss'],
})
export class BreedPage implements OnInit {

  /**
   * Diz qual página o usuário verá
   */
  step: 'breed'|'login' = 'breed'

  constructor(
    private restService: RestaurantService,
    private router: Router,
    private storage: StorageService,
    private utils: Utils
  ) { }

  ngOnInit() {
  }

  /**
   * Checa o CNPJ e a senha do restaurante com a digitada
   * @param login 
   * @param pwd 
   */
  // TODO Mudar para uma rota de login por medidas de segurança
  signin(login: string|number, pwd: number|string) {
    this.restService.getByCnpj(login).subscribe({
      next: rest => {
        if(rest?.senhaMaster !== pwd) this.utils.showAlert({ message: 'CNPJ ou senha incorreto' })
        else this.goToScannerAs('rest')
      },
      error: err => this.utils.showAlert({ message: err })
    })
  }

  /**
   * Altera no storage como por quem o app sendo usado 
   * @param as
   */
  goToScannerAs(as: 'user'|'rest') {
    this.storage.saveV2(environment.storage.v2.breed, as).subscribe({
      next: () => this.router.navigate([environment.routePaths.v2.version])
    })
  }

}
